import { render, staticRenderFns } from "./ActivityGoldAccountDetails.vue?vue&type=template&id=992b76cc&scoped=true&"
import script from "./ActivityGoldAccountDetails.vue?vue&type=script&lang=js&"
export * from "./ActivityGoldAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./ActivityGoldAccountDetails.vue?vue&type=style&index=0&id=992b76cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992b76cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('992b76cc')) {
      api.createRecord('992b76cc', component.options)
    } else {
      api.reload('992b76cc', component.options)
    }
    module.hot.accept("./ActivityGoldAccountDetails.vue?vue&type=template&id=992b76cc&scoped=true&", function () {
      api.rerender('992b76cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/ActivityGoldAccountDetails.vue"
export default component.exports